import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from '../contexts/LanguageContext';

/**
 * Custom hook for language functionality
 * Combines the LanguageContext with react-i18next
 * @returns {Object} - Language utilities
 */
const useLanguage = () => {
  const { t, i18n } = useTranslation();
  const languageContext = useContext(LanguageContext);
  
  if (!languageContext) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  
  const { currentLanguage, availableLanguages, changeLanguage } = languageContext;
  
  return {
    t, // Translation function
    i18n, // i18n instance
    currentLanguage, // Current language code
    availableLanguages, // List of available languages
    changeLanguage, // Function to change language
    
    // Helper to get language name from code
    getLanguageName: (code) => {
      const language = availableLanguages.find(lang => lang.code === code);
      return language ? language.name : code;
    }
  };
};

export default useLanguage;